import { useEffect, useState } from "react";
import Media from "react-media";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LanguageToggle from "src/Common/Components/LanguageToggle";
import { LANGUAGES } from "src/Common/constants";

import UpChevronIcon from "../../../Icons/UpChevronIcon";

import { I18N_NAVBAR_MENU } from "../../constants";

import NavbarHamburger from "../NavbarHamburger";

import "./style.less";

const NavbarRight = () => {
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState("home");

  // For Mobile
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { t, i18n } = useTranslation(["navbar"]);
  const { t: routesT } = useTranslation(["routes"]);

  const handleOnClick = (link) => {
    setActiveMenu(link.name === activeMenu ? "" : link.name);
    if (!link.children) window.scrollTo(0, 0);
  };

  useEffect(() => {
    setIsSidebarOpen(false);
    setActiveMenu("");
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const getPath = () => {
    const currPath = location.pathname;
    let paths = currPath?.split("/");
    if (LANGUAGES.includes(paths[paths.length - 1])) paths.pop();
    return `${paths.join("/")}`;
  };

  const getLinkContent = (link) => {
    const currPath = getPath() || "/";

    const isActive = currPath === link.path;

    const generalLinkProps = {
      className: "link__label" + (isActive ? " active" : ""),
      key: link.path,
      name: link.name,
      target: link.isExternal ? "_blank" : "",
      rel: "noopener noreferrer",
      onClick: () => handleOnClick(link),
    };

    return link.isExternal ? (
      <a href={link.path} {...generalLinkProps}>
        {t(link.name)}
      </a>
    ) : (
      <Link to={link.path} {...generalLinkProps}>
        {t(link.name)}
      </Link>
    );
  };

  const getMenuContent = (link) => {
    const currPath = location.pathname;

    const isActive = currPath.startsWith(link.path);

    const isOpen = activeMenu === link.name;

    return link.children ? (
      <div
        className="link__wrapper"
        onClick={() => handleOnClick(link)}
        key={link.name}
      >
        <div
          className={
            "link__label" +
            (isActive ? " active" : "") +
            (isOpen ? " open" : "")
          }
        >
          <span>{t(link.name)}</span>
          <UpChevronIcon />
        </div>

        <div className={"link__children" + (isOpen ? " open" : "")}>
          <div className="children__content">
            {link.children.map((child) => getLinkContent(child))}
          </div>
        </div>
      </div>
    ) : (
      getLinkContent(link)
    );
  };

  const NAVBAR_MENU = I18N_NAVBAR_MENU(routesT, i18n.language);

  return (
    <Media
      queries={{
        medium: "(max-width: 1000px)",
        large: "(min-width: 1001px)",
      }}
    >
      {(matches) => (
        <div className="navbar-right__content">
          {matches.large && (
            <div className="content__desktop">
              {NAVBAR_MENU.map((menu) => getMenuContent(menu))}
              <LanguageToggle />
            </div>
          )}

          {matches.medium && (
            <>
              <NavbarHamburger
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
              />
              <div className="content__mobile">
                <div className="content__sidebar">
                  {NAVBAR_MENU.map((menu) => getMenuContent(menu))}
                  <LanguageToggle />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </Media>
  );
};

export default NavbarRight;
